import React, { useMemo } from "react";
import ParameterValueAppearance from "../../../ParameterValueAppearance";
import RangeValue from "rs-components/RangeValue";
import NumberInput from "rs-components/Input/components/NumberInput";
import { ParameterFormFields } from "../../../../../..";
import { cellModelParameterUnitsType, findDictionaryItemByValue } from "shared/rsDictionary";
import { NoUnitsType } from "store/recipe/recipe.types";
import * as styles from "./styles.module.scss";
const CellModelRecipeParamConfig = ({ name, parameter, restrictions, editable }) => {
    const unitsAppearance = useMemo(() => {
        const units = findDictionaryItemByValue(cellModelParameterUnitsType, parameter?.units);
        return units?.value === NoUnitsType.NoUnits ? null : units?.label;
    }, [parameter?.units]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ParameterValueAppearance, { parameter: parameter }),
        React.createElement(RangeValue, { className: styles["min-max"], from: {
                component: NumberInput,
                name: `${name}.${ParameterFormFields.min}`,
                placeholder: "Min",
                label: "Min",
                classes: { container: styles.rangeField },
                restrictions: { ...restrictions?.["Min"], IsNumber: true },
            }, to: {
                component: NumberInput,
                name: `${name}.${ParameterFormFields.max}`,
                placeholder: "Max",
                label: "Max",
                classes: { container: styles.rangeField },
                restrictions: { ...restrictions?.["Max"], IsNumber: true },
            }, editable: editable, units: unitsAppearance ?? "" })));
};
export default CellModelRecipeParamConfig;
